var constants = require('./constants');

module.exports = {
    setStatsigUserCookie: function (statsigUser) {
        const date = new Date();
        date.setTime(date.getTime() + constants.DAYS_30);
        document.cookie = 'statsig_user=' + JSON.stringify(statsigUser) + '; path=/; ' + cookieDomain + 'expires=' + date.toUTCString() + '; Secure; SameSite=None;';
    },

    getCookie: function (name) {
        const cookies = document.cookie.split('; ');
        for (let cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) return value;
        }
        return null;
    },
    addGTMTracking: function (client) {
        client.on('experiment_evaluation', function (event) {
            if (event && event.experiment) {
                $('body').trigger('gtm:statsigEvent',
                    {
                        experiment_name: event.experiment.name,
                        variant_name: event.experiment.groupName
                    });
            }
        });
    },
};